import { ColDef, KeyCreatorParams, ValueFormatterParams } from 'ag-grid-community';

export const UNKNOWN_GROUP_NAME = 'N/A';

/** The column defaults every `AgTable` renders with. Kept here rather than
 *  inside the component so a headless grid in a test can be built on the same
 *  config the app ships — a grid without these is not the production grid. */
export const AG_TABLE_DEFAULT_COL_DEF: ColDef = {
  width: 120,
  suppressSizeToFit: true,
  resizable: true,
  sortable: true,
  filter: true,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  keyCreator: (params: KeyCreatorParams) => params.value ?? UNKNOWN_GROUP_NAME,
};

/** The filter defaults every `AgTable` forces onto every column. The identity
 *  `valueFormatter` is why a set filter on a non-string column lists blanks:
 *  ag-Grid discards a filter label that is not a string. Exported for the same
 *  reason as the col def above — a headless grid has to be able to reproduce it. */
export const AG_TABLE_DEFAULT_FILTER_PARAMS = {
  buttons: ['reset'],
  newRowsAction: 'keep',
  valueFormatter: (params: ValueFormatterParams) => params.value,
};
